import React from "react";
import Header from "@/components/header/header";
import Routes from "@/routes/routes";
import {Grid} from "@mui/material";
import { Authenticator } from "@aws-amplify/ui-react";
import { WrapperAuth } from "./auth.style";
import { formStorage } from "@/utils/storage";

const Auth: React.FC<{}> = () => {
  return (
    <WrapperAuth>
      <Authenticator.Provider>
        <Authenticator
          socialProviders={["google"]}
          hideSignUp
          className="authenticator"
        >
          {({ signOut, user }) => (
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Header signOut={async () => {
                  if (signOut) {
                    await formStorage.clearFormData();
                    signOut();
                  }
                }} />
              </Grid>
              <Grid item xs={12}>
                {user?.userId ? (
                  <>
                    <Routes />
                  </>
                ) : (
                  <div>Cargando</div>
                )}
              </Grid>
            </Grid>
          )}
        </Authenticator>
      </Authenticator.Provider>
    </WrapperAuth>
  );
};

export default Auth;
